<script>
  import { Select } from '@mg/mg-ui'

  import { getValueByPath } from 'element-ui/lib/utils/util'
  
  // import { uniqBy } from 'lodash-es'

  export default {
    name: Select.name,
    extends: Select,
    props: {
      searchLimit: {
        default: 1,
        type: Number,
      },
    },

    methods: {
      loadData(params) {
        this.scrollLoading = true
        if (this.searchLimit == 1) {
          if (this.$attrs.remote) {
            params = { ...params, page: this.page, size: this.size }
          }
          return this.loadMethod({ ...this.loadParams, ...params })
            .then((res) => {
              this.page++
              return typeof this.resultProp === 'function' ? this.resultProp(res) : getValueByPath(res, this.resultProp)
            })
            .finally(() => {
              this.scrollLoading = false
            })
        } else if (this.searchLimit !== 1 && params[this.searchKey].length >= this.searchLimit) {
          if (this.$attrs.remote) {
            params = { ...params, page: this.page, size: this.size }
          }
          return this.loadMethod({ ...this.loadParams, ...params })
            .then((res) => {
              this.page++
              return typeof this.resultProp === 'function' ? this.resultProp(res) : getValueByPath(res, this.resultProp)
            })
            .finally(() => {
              this.scrollLoading = false
            })
        } else
          return new Promise((resolve) => {
            this.scrollLoading = false
            resolve([])
          })
      },
      mapOptions(data = []) {
        if (!this.map) return data
        let map = this.map
        if (typeof map !== 'function') {
          map = (item) => {
            const res = {}
            for (const key in this.map) {
              res[key] = item[this.map[key]]
            }
            return res
          }
        }
        // 测试 -- 暂不手动去重 -- uniqBy(, 'value')
        return data.map(map)
      },
    },
  }
</script>

<style lang="scss" scoped></style>
